<template>
  <div class="pb-3">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <b-form-fieldset label="Jenis Identitas">
          <model-list-select class="form-control" :list=" ref_identitas " option-value="kd_id" option-text="URAIAN"
            :value=" model( 'jns_identitas' ) " @input=" updateBarpin( 'jns_identitas',$event ) " name="Jenis Identitas"
            v-validate=" 'required' " placeholder="Jenis Identitas"></model-list-select>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12 col-md-6">
        <b-form-fieldset label="Nomor Identitas">
          <b-form-input name="Nomor Identitas" type="text" :value=" model( 'no_identitas' ) " @input=" updateBarpin( 'no_identitas',$event ) "
            placeholder="Nomor Identitas" v-validate=" model('jns_identitas') === '5' ? 'required|min:16' : 'required' " :class="errors.has('Nomor Identitas') ? 'is-invalid' : ''"></b-form-input>
            <div v-show="errors.has('Nomor Identitas')" class="invalid-feedback">{{ errors.first('Nomor Identitas') }}</div>
        </b-form-fieldset>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <b-form-fieldset label="Nama">
          <b-form-input type="text" :value=" model( 'nama' ) " @input=" updateBarpin( 'nama',$event ) "
            placeholder="Nama Pemohon"></b-form-input>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12 col-md-6">
        <b-form-fieldset label="Alamat">
          <b-form-input type="text" :value=" model( 'alamat' ) " @input=" updateBarpin( 'alamat',$event ) "
            placeholder="Alamat"></b-form-input>
        </b-form-fieldset>
      </div>
    </div>
    <div class="row mx-3">
      <p class="mr-3">Menggunakan Kuasa?</p>
      <c-switch type="default" v-model=" fl_kuasa " variant="primary" :pill=" true " :checked=" true " />
    </div>
    <div v-if=" fl_kuasa ">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Jenis Identitas yang dikuasakan">
            <model-list-select class="form-control" :list=" ref_identitas " option-value="kd_id" option-text="URAIAN"
              :value=" model( 'jns_identitas_kuasa' ) " @input=" updateBarpin( 'jns_identitas_kuasa',$event ) "
              name="Jenis Identitas" v-validate=" 'required' " placeholder="Jenis Identitas"></model-list-select>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Nomor Identitas yang dikuasakan">
            <b-form-input name="Nomor Identitas yang dikuasakan" type="text" :value=" model( 'no_identitas_kuasa' ) "
              @input=" updateBarpin( 'no_identitas_kuasa',$event ) " placeholder="Nomor Identitas yang dikuasakan" v-validate=" model('jns_identitas_kuasa') === '5' ? 'min:16' : '' " :class="errors.has('Nomor Identitas yang dikuasakan') ? 'is-invalid' : ''">
            </b-form-input>
            <div v-show="errors.has('Nomor Identitas yang dikuasakan')" class="invalid-feedback">{{ errors.first('Nomor Identitas yang dikuasakan') }}</div>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Nama yang dikuasakan">
            <b-form-input type="text" :value=" model( 'nama_kuasa' ) " @input=" updateBarpin( 'nama_kuasa',$event ) "
              placeholder="Nama Pemohon"></b-form-input>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Alamat yang dikuasakan">
            <b-form-input type="text" :value=" model( 'alamat_kuasa' ) "
              @input=" updateBarpin( 'alamat_kuasa',$event ) " placeholder="Alamat yang dikuasakan"></b-form-input>
          </b-form-fieldset>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <b-form-fieldset label="Moda Angkutan">
          <model-list-select class="form-control" :list=" [
            {id_angkutan: '1',nama_angkutan: 'Laut'},
            {id_angkutan: '2',nama_angkutan: 'Udara'},
            {id_angkutan: '3',nama_angkutan: 'Darat'}
          ] " option-value="id_angkutan" :custom-text=" ( item ) => `${item.id_angkutan} - ${item.nama_angkutan}` "
            :value=" model( 'moda_angkutan' ) " @input=" updateBarpin( 'moda_angkutan',$event ) " name="Jenis Perizinan"
            v-validate=" 'required' " placeholder="Moda Angkutan"></model-list-select>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12 col-md-6">
        <b-form-fieldset label="Tempat Penimbunan (Gudang)">
          <model-list-select class="form-control" :list=" gudang " option-value="ID_GUDANG"
            :custom-text=" ( item ) => `${item.ID_GUDANG} - ${item.NM_GUDANG}` " name="Jenis Perizinan"
            :value=" model( 'id_gudang' ) " @input=" updateBarpin( 'id_gudang',$event ) " v-validate=" 'required' "
            placeholder="Tempat Penimbunan"></model-list-select>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12 col-md-6">
        <b-form-fieldset label="Nama Sarana Pengangkut / Lori">
          <b-form-input type="text" :value=" model( 'nama_sarkut' ) " @input=" updateBarpin( 'nama_sarkut',$event ) "
            placeholder="Nama Sarana Angkutan">
          </b-form-input>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12 col-md-6">
        <b-form-fieldset label="Nomor Voyage / Plat Nomor Kendaraan">
          <b-form-input type="text" :value=" model( 'no_voyage' ) " @input=" updateBarpin( 'no_voyage',$event ) "
            placeholder="Nomor Voyage / Plat Nomor Kendaraan">
          </b-form-input>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12 col-md-6">
        <b-form-fieldset label="Pelabuhan Muat">
          <model-list-select class="form-control" :list=" pelabuhan " option-value="ID_LOKASI"
            :custom-text=" ( item ) => `${item.ID_LOKASI} - ${item.NM_LOKASI}` " :value=" model( 'pel_muat' ) "
            @input=" updateBarpin( 'pel_muat',$event ) " name="Jenis Perizinan" v-validate=" 'required' "
            placeholder="Pelabuhan Muat"></model-list-select>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12 col-md-6">
        <b-form-fieldset label="Pelabuhan Tujuan">
          <model-list-select class="form-control" :list=" pelabuhan " option-value="ID_LOKASI"
            :custom-text=" ( item ) => `${item.ID_LOKASI} - ${item.NM_LOKASI}` " name="Jenis Perizinan"
            :value=" model( 'pel_tujuan' ) " @input=" updateBarpin( 'pel_tujuan',$event ) " v-validate=" 'required' "
            placeholder="Pelabuhan Tujuan"></model-list-select>
        </b-form-fieldset>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-4">
        <b-form-fieldset label="Bruto">
          <!-- <b-form-input type="number" placeholder="Bruto Barang"></b-form-input> -->
          <vue-numeric class="form-control" currency="Kg" currency-symbol-position="suffix" separator="."
            placeholder="Bruto Barang" v-bind:precision=" 2 " :value=" model( 'bruto' ) "
            @input=" updateBarpin( 'bruto',$event ) ">
          </vue-numeric>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12 col-md-4">
        <b-form-fieldset label="Netto">
          <!-- <b-form-input
            type="number"

            placeholder="Netto Barang"
          ></b-form-input> -->
          <vue-numeric class="form-control" currency="Kg" currency-symbol-position="suffix" separator="."
            placeholder="Netto Barang" v-bind:precision=" 2 " :value=" model( 'netto' ) "
            @input=" updateBarpin( 'netto',$event ) ">
          </vue-numeric>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12 col-md-4">
        <b-form-fieldset label="Estimasi Tanggal Pengeluaran">
          <b-form-input type="date" :value=" model( 'tgl_pengeluaran' ) "
            @input=" updateBarpin( 'tgl_pengeluaran',$event ) ">
          </b-form-input>
        </b-form-fieldset>
      </div>
    </div>
    <div>
      <table class="table table-borderless table-responsive">
        <thead>
          <tr>
            <th>File Upload</th>
            <th>Nomor</th>
            <th>Tanggal</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Identitas (KTP/NPWP/SIM)<code>*</code></td>
            <td>
              <b-form-input disabled type="text" size="50" :value=" model( 'no_identitas' ) "
                @input=" updateBarpin( 'no_identitas',$event ) "></b-form-input>
            </td>
            <td></td>
            <td>
              <b-form-file :plain=" true " ref="file-input"
                @change=" ( e ) => fileChanged( e,'file_identitas_penerima' ) " class="mb-2"></b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_identitas_penerima ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a target="_blank" v-if=" this.$store.state.barpin.files.file_identitas_penerima "
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_identitas_penerima}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr v-if=" $store.state.barpin.header.jns_aju === '2' ">
            <td>Nomor STNK<code>*</code></td>
            <td>
              <b-form-input placeholder="Nomor STNK" :value=" model( 'no_stnk' ) "
                @input=" updateBarpin( 'no_stnk',$event ) " type="text">
              </b-form-input>
            </td>
            <td>
              <b-form-input type="date" :value=" model( 'tgl_stnk' ) " @input=" updateBarpin( 'tgl_stnk',$event ) "
                v-validate=" 'required' "></b-form-input>
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" @change=" ( e ) => fileChanged( e,'file_stnk' ) "
                class="mb-2">
              </b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_stnk ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_stnk " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_stnk}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr v-if=" $store.state.barpin.header.jns_aju === '2' ">
            <td>Nomor BPKB <code>*</code> </td>
            <td>
              <b-form-input placeholder="Nomor BPKB" :value=" model( 'no_bpkb' ) "
                @input=" updateBarpin( 'no_bpkb',$event ) " type="text">
              </b-form-input>
            </td>
            <td>
              <b-form-input type="date" :value=" model( 'tgl_bpkb' ) " @input=" updateBarpin( 'tgl_bpkb',$event ) "
                v-validate=" 'required' "></b-form-input>
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" @change=" ( e ) => fileChanged( e,'file_bpkb' ) "
                class="mb-2">
              </b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_bpkb ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_bpkb " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_bpkb}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr v-if=" $store.state.barpin.header.jns_aju === '2' ">
            <td>Nomor Surat Jalan<code>*</code></td>
            <td>
              <b-form-input placeholder="Nomor Surat Jalan" :value=" model( 'no_surat_jalan' ) "
                @input=" updateBarpin( 'no_surat_jalan',$event ) " type="text">
              </b-form-input>
            </td>
            <td>
              <b-form-input type="date" :value=" model( 'tgl_surat_jalan' ) "
                @input=" updateBarpin( 'tgl_surat_jalan',$event ) " v-validate=" 'required' "></b-form-input>
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" @change=" ( e ) => fileChanged( e,'file_surat_jalan' ) "
                class="mb-2">
              </b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_surat_jalan ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_surat_jalan " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_surat_jalan}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr v-if=" fl_kuasa ">
            <td>Identitas Kuasa (KTP/NPWP/SIM)<code>*</code></td>
            <td>
              <b-form-input :value=" model( 'no_identitas_kuasa' ) "
                @input=" updateBarpin( 'no_identitas_kuasa',$event ) " disabled type="text"></b-form-input>
            </td>
            <td></td>
            <td>
              <b-form-file :plain=" true " ref="file-input"
                @change=" ( e ) => fileChanged( e,'file_identitas_pengirim' ) " class="mb-2"></b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_identitas_pengirim ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_identitas_pengirim " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_identitas_pengirim}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>

          <tr v-if=" $store.state.barpin.header.jns_aju === '1' ">
            <td>Kartu Keluarga<code>*</code></td>
            <td>
              <b-form-input placeholder=" Nomor Kartu Keluarga" :value=" model( 'no_kk' ) "
                @input=" updateBarpin( 'no_kk',$event ) " type="text">
              </b-form-input>
            </td>
            <td>
              <!-- <b-form-input
                type="date"
                :disabled="this.$store.state.barpin.isDisabled"
                :value="model('tgl_kk')"
                @input="updateBarpin('tgl_kk', $event)"
              ></b-form-input>-->
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" class="mb-2"
                @change=" ( e ) => fileChanged( e,'file_kk' ) ">
              </b-form-file>
              <!-- <file-pond
              name="test"
              ref="pond"
              label-idle="Drop files here..."
              accepted-file-types="image/jpeg, image/png, application/pdf"
              v-bind:files="myFiles"
              :server="options"
              />-->
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_kk ">Belum Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_kk " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_kk}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr v-if=" $store.state.barpin.header.jns_aju === '1' ">
            <td>Surat Pindah Dukcapil</td>
            <td>
              <b-form-input :disabled=" this.$store.state.barpin.isDisabled " placeholder="Nomor Surat Dukcapil"
                :value=" model( 'no_dukcapil' ) " @input=" updateBarpin( 'no_dukcapil',$event ) "
                v-validate=" 'required' " type="text">
              </b-form-input>
            </td>
            <td>
              <b-form-input type="date" :value=" model( 'tgl_dukcapil' ) "
                @input=" updateBarpin( 'tgl_dukcapil',$event ) " v-validate=" 'required' "></b-form-input>
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" @change=" ( e ) => fileChanged( e,'file_dukcapil' ) "
                class="mb-2">
              </b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_dukcapil ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_dukcapil " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_dukcapil}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr v-if=" $store.state.barpin.header.jns_aju === '1' ">
            <td>Surat Keterangan Pindah (Surat Mutasi/Lainnya)<code>*</code></td>
            <td>
              <b-form-input :disabled=" this.$store.state.barpin.isDisabled " placeholder="Nomor Surat Pindah"
                :value=" model( 'no_surat_pindah' ) " @input=" updateBarpin( 'no_surat_pindah',$event ) "
                v-validate=" 'required' " type="text">
              </b-form-input>
            </td>
            <td>
              <b-form-input type="date" :value=" model( 'tgl_pindah' ) " @input=" updateBarpin( 'tgl_pindah',$event ) "
                v-validate=" 'required' "></b-form-input>
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" @change=" ( e ) => fileChanged( e,'file_pindah' ) "
                class="mb-2">
              </b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_pindah ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_pindah " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_pindah}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr v-if=" fl_kuasa ">
            <td>Surat Kuasa</td>
            <td>
              <b-form-input placeholder="Nomor Surat Kuasa" type="text" :value=" model( 'no_surat_kuasa' ) "
                @input=" updateBarpin( 'no_surat_kuasa',$event ) "></b-form-input>
            </td>
            <td>
              <b-form-input type="date" :value=" model( 'tgl_surat_kuasa' ) "
                @input=" updateBarpin( 'tgl_surat_kuasa',$event ) "></b-form-input>
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" class="mb-2"
                @change=" ( e ) => fileChanged( e,'file_kuasa' ) ">
              </b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_kuasa ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_kuasa " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_kuasa}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr v-if=" $store.state.barpin.header.jns_aju === '1' ">
            <td>Surat Pernyataan<code>*</code></td>
            <td>
              <b-form-input placeholder="Nomor Surat Pernyataan" type="text" :value=" model( 'no_surat_pernyataan' ) "
                @input=" updateBarpin( 'no_surat_pernyataan',$event ) "></b-form-input>
            </td>
            <td>
              <b-form-input type="date" :value=" model( 'tgl_surat_pernyataan' ) "
                @input=" updateBarpin( 'tgl_surat_pernyataan',$event ) "></b-form-input>
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" class="mb-2"
                @change=" ( e ) => fileChanged( e,'file_pernyataan' ) "></b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_pernyataan ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_pernyataan " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_pernyataan}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr v-if=" $store.state.barpin.header.jns_aju === '1' ">
            <td>Surat Rekomendasi BP</td>
            <td>
              <b-form-input placeholder="Nomor Surat Pernyataan" type="text" :value=" model( 'no_surat_rekombp' ) "
                @input=" updateBarpin( 'no_surat_rekombp',$event ) "></b-form-input>
            </td>
            <td>
              <b-form-input type="date" :value=" model( 'tgl_surat_rekombp' ) "
                @input=" updateBarpin( 'tgl_surat_rekombp',$event ) "></b-form-input>
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" class="mb-2"
                @change=" ( e ) => fileChanged( e,'file_rekombp' ) ">
              </b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_rekombp ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_rekombp " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_rekombp}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr>
            <td>Packing List<code>*</code></td>
            <td>
              <b-form-input placeholder="Nomor Packing List" type="text" :value=" model( 'no_pl' ) "
                @input=" updateBarpin( 'no_pl',$event ) "></b-form-input>
            </td>
            <td>
              <b-form-input type="date" :value=" model( 'tgl_pl' ) " @input=" updateBarpin( 'tgl_pl',$event ) ">
              </b-form-input>
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" class="mb-2"
                @change=" ( e ) => fileChanged( e,'file_pl' ) ">
              </b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_pl ">Belum Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_pl " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_pl}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr v-if=" $store.state.barpin.header.jns_aju === '2' ">
            <td>Bukti Gesek Kendaraan<code>*</code></td>
            <td>
              <b-form-input placeholder="Nomor Gesek Kendaraan" type="text" :value=" model( 'no_bukti_gesek' ) "
                @input=" updateBarpin( 'no_bukti_gesek',$event ) "></b-form-input>
            </td>
            <td>
              <b-form-input type="date" :value=" model( 'tgl_bukti_gesek' ) "
                @input=" updateBarpin( 'tgl_bukti_gesek',$event ) "></b-form-input>
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" class="mb-2"
                @change=" ( e ) => fileChanged( e,'file_bukti_gesek' ) ">
              </b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_bukti_gesek ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_bukti_gesek " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_bukti_gesek}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
          <tr>
            <td>Lain-lain</td>
            <td>
            </td>
            <td>
            </td>
            <td>
              <b-form-file :plain=" true " ref="file-input" @change=" ( e ) => fileChanged( e,'file_lain_lain' ) "
                class="mb-2">
              </b-form-file>
            </td>
            <td>
              <span class="badge badge-secondary" v-if=" !this.$store.state.barpin.files.file_lain_lain ">Belum
                Upload</span>
              <span class="badge badge-success" v-else>Sudah upload</span>
            </td>
            <td>
              <a v-if=" this.$store.state.barpin.files.file_lain_lain " target="_blank"
                :href=" `${this.$http.options.base}/file/ppftz/${this.$route.params.id}/${this.$store.state.barpin.files.file_lain_lain}` ">
                <b-button variant="warning">
                  <i class="fa fa-download"></i>
                </b-button>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- <model-list-select
    class="form-control"
    :list="jnijin"
    v-model="isian.jnperijinan"
    option-value="id_ijin"
    option-text="nama_ijin"
    name="Jenis Perizinan"
    v-validate="'required'"
    placeholder="-- Pilih Jenis Perijinan --"
  ></model-list-select>-->
</template>


<script>
import cSwitch from '@/components/Switch'
import {ModelListSelect} from 'vue-search-select'
import {mapActions} from 'vuex'
import swal from 'sweetalert'

export default {
  components: {
    cSwitch,
    ModelListSelect
  },
  data () {
    return {
      tes: 123165,
      pelabuhan: [],
      gudang: [],
      ref_identitas: [{kd_id: '2', URAIAN: 'KTP'}, {kd_id: '3', URAIAN: 'Paspor'}, {kd_id: '4', URAIAN: 'Lainnya'}, {kd_id: '5', URAIAN: 'NPWP 16 Digit'}],
      file: {
        file: '',
        fileSize: '',
        fileExt: '',
        fileName: ''
      }
    }
  },
  created () {
    this.getPelabuhan()
    this.getGudang()
  },
  methods: {
    updateBarpin (where, event) {
      // console.log(event)
      this.$store.commit('barpin/UPDATE_HEADER', {value: event, where: where})
    },
    model (name) {
      return this.$store.state.barpin.header[name]
    },
    getPelabuhan () {
      this.$http.get('ref/peldn').then((response) => {
        this.pelabuhan = response.data
      })
    },
    getGudang () {
      this.$http.get('ref/idgudang').then((response) => {
        this.gudang = response.data
      })
    },
    ...mapActions({
      upload: 'barpin/setFile'
    }),
    async fileChanged (e, key) {
      // console.log(id)
      // this.$Progress.start()
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      this.file.fileSize = e.target.files[0].size / 1024
      this.file.fileExt = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      this.file.fileName = e.target.files[0].name
      fileReader.onload = (e) => {
        this.file.file = e.target.result
        this.uploadFile(key)
        // this.$Progress.finish()
      }
    },
    uploadFile (key) {
      var data = {
        ...this.file,
        no_aju: this.$route.params.id,
        key_file: key
      }
      this.upload(data).then(() => {
        swal('success', 'Berhasil meng-upload dokumen', 'success')
      }).catch((error) => {
        // swal('error', JSON.stringify(JSON.parse(error.bodyText).errors), 'error')
        swal('error', JSON.parse(error.bodyText.message), 'error')
      })
    }
  },
  computed: {
    fl_kuasa: {
      get () {
        return this.$store.state.barpin.header.fl_kuasa
      },
      set (value) {
        this.$store.commit('barpin/UPDATE_HEADER', {
          value: value,
          where: 'fl_kuasa'
        })
      }
    },
    alamat: {
      get () {
        return this.$store.state.barpin.header.alamat
      },
      set (value) {
        this.$store.commit('barpin/UPDATE_HEADER', {
          value: value,
          where: 'alamat'
        })
      }
    },
    alamat_kuasa: {
      get () {
        return this.$store.state.barpin.header.alamat_kuasa
      },
      set (value) {
        this.$store.commit('barpin/UPDATE_HEADER', {
          value: value,
          where: 'alamat_kuasa'
        })
      }
    },
    tesCurrency: {
      get () {
        if (!this.tes) return 'Rp0.00'
        return 'Rp' + parseFloat(this.tes).toFixed(2)
      },
      set (value) {
        this.tes = value
      }
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/ppftz/perekaman/Step-1.vue?bd7cebac